export default __webpack_public_path__ + "static/media/Z_wdt_c_cap_3.4a8c22b3.mp3";